const DEV_URL = 'https://paddee-api-staging.herokuapp.com';
const PROD_URL = 'https://paddee-api.herokuapp.com';

export default function getBaseUrl() {
  return PROD_URL;
  if (process.env.NODE_ENV !== 'production') {
    return DEV_URL;
  }
  if (window.location.hostname.indexOf('staging') >= 0) {
    return DEV_URL;
  } else {
    return PROD_URL;
  }
}



// WEBPACK FOOTER //
// ./src/utils/base-url.js